import { percentToBps, SideEnum, type CustomerTrade } from '@talos/kyoko';
import { useCallback, useState } from 'react';
import type { CustomerTradeForm } from './types';

export function getInitialCustomerTradeForm(): CustomerTradeForm {
  return {
    counterparty: '',
    symbol: '',
    side: SideEnum.Buy,
    currency: '',
    quantity: '',
    price: '',
    amount: '',
    amountCurrency: '',
    salesCommission: '',
    clTradeID: '',
    tradeID: '',
    marketAccount: '',
    comments: '',
  };
}

export function customerTradeToForm(customerTrade: CustomerTrade): CustomerTradeForm {
  return {
    ...getInitialCustomerTradeForm(),
    counterparty: customerTrade.Counterparty ?? '',
    symbol: customerTrade.Symbol,
    side: customerTrade.Side,
    currency: customerTrade.Currency,
    quantity: customerTrade.Quantity,
    price: customerTrade.Price,
    amount: customerTrade.Amount,
    amountCurrency: customerTrade.AmountCurrency,
    clTradeID: customerTrade.ClTradeID ?? '',
    tradeID: customerTrade.TradeID,
    marketAccount: customerTrade.MarketAccount,
    comments: customerTrade.Comments ?? '',
    salesCommission: percentToBps(customerTrade.SalesCommission),
    fee: customerTrade.Fee ?? '',
    feeCurrency: customerTrade.FeeCurrency,
  };
}

export function useCustomerTradeForm(initialForm: CustomerTradeForm) {
  const [form, setForm] = useState(initialForm);

  const updateForm = useCallback((payload: Partial<CustomerTradeForm>) => {
    setForm(currentForm => ({ ...currentForm, ...payload }));
  }, []);

  const resetForm = useCallback(() => {
    setForm(getInitialCustomerTradeForm());
  }, []);

  return { form, updateForm, resetForm };
}
